// Copyright 2025, University of Maryland, All Rights Reserved
import type { FC } from 'react'
import { Label, Input } from '@/components/ui'
import type { DatasourceConfigProps, FullTextDatasourceSettings } from '../types'

/**
 * Configuration form for FullText datasource.
 * Workspace override + document listing filters for analysis nodes.
 */
export const FullTextConfig: FC<DatasourceConfigProps<FullTextDatasourceSettings>> = ({
  config,
  onChange,
}) => {
  const sourceOrgId = config?.sourceOrgId ?? ''
  const sourceWsId = config?.sourceWsId ?? ''
  const groupId = config?.groupId ?? ''

  return (
    <div className="space-y-4">
      <div className="space-y-2">
        <Label htmlFor="source-org-id">Source Organization ID</Label>
        <p className="text-xs text-muted-foreground">
          Fetch documents from a different organization. Leave empty to use current org.
        </p>
        <Input
          id="source-org-id"
          value={sourceOrgId}
          onChange={(e) => onChange('sourceOrgId', e.target.value || null)}
          placeholder="Current organization"
          className="w-48"
        />
      </div>

      <div className="space-y-2">
        <Label htmlFor="source-ws-id">Source Workspace ID</Label>
        <p className="text-xs text-muted-foreground">
          Fetch documents from a different workspace. Leave empty to use current workspace.
        </p>
        <Input
          id="source-ws-id"
          value={sourceWsId}
          onChange={(e) => onChange('sourceWsId', e.target.value || null)}
          placeholder="Current workspace"
          className="w-48"
        />
      </div>

      <div className="space-y-2">
        <Label htmlFor="group-id">Group ID Filter</Label>
        <p className="text-xs text-muted-foreground">
          Filter by group ID (e.g., Workday REQ#). Leave empty for all groups.
        </p>
        <Input
          id="group-id"
          value={groupId}
          onChange={(e) => onChange('groupId', e.target.value || null)}
          placeholder="All groups"
          className="w-48"
        />
      </div>
    </div>
  )
}
